import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconEye: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9907 5.25C8.22194 5.25 5.25006 7.62187 1.69694 11.4984C1.43913 11.7844 1.43444 12.2109 1.69225 12.4969C4.73444 15.8578 7.41569 18.75 11.9907 18.75C16.5094 18.75 19.8985 15.1078 22.3079 12.4688C22.5563 12.1969 22.5704 11.7844 22.3313 11.4984C19.8751 8.52187 16.4766 5.25 11.9907 5.25ZM12.1969 16.2141C9.71256 16.3266 7.66882 14.2828 7.786 11.8031C7.88444 9.6375 9.63757 7.88438 11.8032 7.78594C14.2876 7.67344 16.3313 9.71719 16.2141 12.1969C16.1157 14.3625 14.3626 16.1156 12.1969 16.2141ZM12.1454 9.00469C12.0516 9.24844 12.0001 9.51562 12.0001 9.79688C12.0001 11.0109 12.961 12 14.1423 12C14.4469 12 14.7329 11.9344 14.9954 11.8172C14.9954 11.8477 14.9965 11.8781 14.9977 11.9086C14.9989 11.9391 15.0001 11.9695 15.0001 12C15.0001 13.7297 13.5282 15.1219 11.7704 14.9906C10.3032 14.8781 9.12194 13.6969 9.00944 12.2297C8.87819 10.4719 10.2704 9 12.0001 9C12.0265 9 12.0516 9.00123 12.0762 9.00243C12.0996 9.00357 12.1225 9.00469 12.1454 9.00469Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconEye;
